export const GET_LIST = 'getList';
export const GET_SINGLE = 'getSingle';
export const CREATE = 'create';
export const UPDATE = 'update';
export const DELETE = 'delete';
